import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const REFERRER_KEY = "tracking:last_page_path";
const LPV_KEY = "tracking:last_pageview";
const TTL_MS = 1500;

type LastPageView = { path: string; ts: number };

export function shouldSendPageView(path: string): boolean {
    try {
        const raw = sessionStorage.getItem(LPV_KEY);
        const now = Date.now();

        if (!raw) return true;

        const last: LastPageView = JSON.parse(raw);
        return !(last.path === path && now - last.ts < TTL_MS);

    } catch {
        return true;
    }
}

export function markPageViewSent(path: string) {
    const now = Date.now();
    sessionStorage.setItem(LPV_KEY, JSON.stringify({path, ts: now} satisfies LastPageView));
}

export function getLastPagePath(): string | null {
    return sessionStorage.getItem(REFERRER_KEY);
}

export function setLastPagePath(path: string) {
    sessionStorage.setItem(REFERRER_KEY, path);
}

export function RouteChangeTracker() {
    const location = useLocation();

    useEffect(() => {
        const page_path = location.pathname + location.search + location.hash;

        if (!shouldSendPageView(page_path)) return;
        markPageViewSent(page_path);

        const prev = getLastPagePath();

        globalThis.GewissTracking?.pageView({
            page_path,
            page_location: window.location.href,
            referrer: prev ?? document.referrer ?? undefined,
        });

        setLastPagePath(page_path);
    }, [location.pathname, location.search, location.hash]);

    return null;
}